function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  className: styles["a"] || "a",
  d: "M8 16c0-.828.447-2 1-2v-2H7V5l.8-5H4.2L5 5v7H3v2c.553 0 1 1.172 1 2 0 .828-.447 2-1 2v4c0 1 1 2 3 2s3-1 3-2v-4c-.553 0-1-1.172-1-2M20.9 5c0 1.992-.9 4-2.9 5v12c0 1-1 2-2 2s-2-1-2-2V10c-2-1-2.9-3.008-2.9-5A4.895 4.895 0 0114 .535V5l2 2 2-2V.535A4.895 4.895 0 0120.9 5"
})));